<template>
  <layout :drawerShow="false" :drawerWidth="350">
    <template slot="nav">
      <v-tabs>
        <v-tab :to="{ name: 'AdminUsers' }">Utilisateurs</v-tab>
      </v-tabs>
    </template>
    <template #drawer>
      <div>
        <v-row no-gutters class="pt-2 pr-1">
          <v-col cols="12">
            <v-subheader light class="pa-0 mt-5 mb-0 mx-0 form-subheader"
            >Type Agent
            </v-subheader
            >
            <v-divider></v-divider>
          </v-col>

          <v-col cols="6">
            <v-checkbox
                v-for="(bs, index) in 2"
                :key="'bs-' + index"
                v-model="searchform.onplaceAgent"
                :label="index == 0 ? 'Agent sur place': 'Agent'"
                :value="index == 0 ? 'true': 'false'"
                :class="'pt-1 ' + (index == 0 ? 'mt-2' : 'mt-0')"
                height="1"
            >
            </v-checkbox>
          </v-col>
          <v-col cols="12">
            <v-subheader light class="pa-0 mt-5 mb-0 mx-0 form-subheader"
            >Statut Utilisateurs
            </v-subheader
            >
            <v-divider></v-divider>
          </v-col>

          <v-col cols="6">
            <v-checkbox
                v-for="(bs, index) in 2"
                :key="'bs-' + index"
                v-model="searchform.active"
                :label="index == 0 ? 'Actif': 'Inactif'"
                :value="index == 0 ? 'true': 'false'"
                :class="'pt-1 ' + (index == 0 ? 'mt-2' : 'mt-0')"
                height="1"
            >
            </v-checkbox>
          </v-col>
          <v-col cols="6">
            <v-checkbox
                v-for="(bs, index) in 2"
                :key="'vacant-' + index"
                v-model="searchform.vacant"
                :label="index == 0 ? 'Présent': 'Absent'"
                :value="index == 0 ? 'false': 'true'"
                :class="'pt-1 ' + (index == 0 ? 'mt-2' : 'mt-0')"
                height="1"
            >
            </v-checkbox>
          </v-col>
          <v-spacer cols="6"></v-spacer>

          <v-col cols="12">
            <v-subheader light class="pa-0 mt-5 mb-0 mx-0 form-subheader">
              Sites
            </v-subheader>
            <v-divider></v-divider>
          </v-col>

          <v-col cols="12">
            <v-checkbox
                v-for="(site, index) in allSites"
                :key="'site-' + index"
                v-model="searchform.sites"
                :label="site"
                :value="site"
                :class="'pt-1 ' + (index == 0 ? 'mt-2' : 'mt-0')"
                height="1"
            >
            </v-checkbox>
          </v-col>

          <v-spacer cols="6"></v-spacer>

        </v-row>
        <!--        <smart-btn @click.native="filterUsers" block primary
                >Rechercher
                </smart-btn
                >
                <smart-btn
                    block
                    tertiary
                    @click.native="
                    clearSearchform();
                    loadData();
                  "
                >Réinitialiser la recherche
                </smart-btn
                >-->
      </div>
    </template>

    <template slot="content">

      <v-data-table class=" elevation-1 tbl ma-4 "
                    dense
                    @input="$emit('update:selectedRows', $event)"
                    :items="filteredUsers"
                    :items-per-page="-1"
                    search-field="name"
                    item-key="id"
                    :headers="headers"
                    hide-default-footer>

        <template #item="{item}">
          <tr @click="changeVacation(item)">
            <td>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <div
                      v-bind="attrs"
                      v-on="on">
                    <v-icon>{{
                        item.active && !item.isOnPlaceAgentId ? 'mdi-account' : !item.active ? 'mdi-account-off' : 'mdi-account-arrow-right-outline'
                      }}
                    </v-icon>
                    {{ item.name }}
                  </div>
                </template>
                <span>{{ item.isOnPlaceAgentId ? 'Agent sur place' : 'Agent' }}</span>
              </v-tooltip>

            </td>
            <td>{{ item.email }}</td>
            <td :class="item.active ? 'green--text':'red--text'">{{ item.active ? 'ACTIF' : 'INACTIF' }}</td>
            <td>
              <v-chip @click="changeVacation(item)" outlined small color="orange"
                      v-if="item.vacant"> Absent
              </v-chip>
              <v-chip @click="changeVacation(item)" small outlined color="green" v-else>Présent</v-chip>
            </td>
            <td>
              <v-row dense>
                <div v-for="(role, i) in item.groups" :key="i">
                  <v-chip label outlined small>{{ role.name }}</v-chip>
                </div>
              </v-row>
            </td>
            <td>
              <v-row dense>
                <div v-for="(role, i) in item.roles" :key="i">
                  <v-chip label outlined small>{{ role.name }}</v-chip>
                </div>
              </v-row>
            </td>

            <td v-for="site in allSites" :key="site">
              <div class="d-flex justify-space-around">
                <v-icon small v-if="item[site]" color="green" class="">mdi-check-circle-outline</v-icon>
                <div v-else></div>
              </div>
            </td>
          </tr>


        </template>
      </v-data-table>
      <smart-dialog v-model="userDialog.show" title="Modifier la présence de l'utilisateur ">
        <div class="d-flex flex-col justify-center ma-4">
          <span>Si l'utilisateur est absent, il ne se verra plus attribuer de dossier durant son absence</span>
        </div>
        <template #actions>
          <div class=" w-full d-flex justify-space-between align-center " style="gap: 8px">
            <span class="font-weight-medium">Statut Utilisateur:</span>
            <smart-btn secondary @click.native="setPresent" class=""
            >Présent
            </smart-btn>
            <smart-btn action="delete" secondary @click.native="setVacant" class=""
            >Absent
            </smart-btn>
          </div>

        </template>
      </smart-dialog>


      <!--      <v-container fluid>
              <v-card class="mt-1" style="max-width:1024px;margin:auto">
                <v-row>
                  <v-col cols="3" class="left-col overflow-auto">
                    <v-treeview
                        ref="treeview"
                        shaped
                        hoverable
                        activatable
                        open-on-click
                        transition
                        overflow-x-auto
                        open-all
                        :items="items"
                        :active.sync="active"
                        :open.sync="open"
                        :load-children="loadUsers"
                    >
                      <template v-slot:prepend="{ item }">
                        <v-icon
                            v-if="!item.children"
                        >{{
                            item.active && !item.isOnPlaceAgentId ? 'mdi-account' : !item.active ? 'mdi-account-off' : 'mdi-account-arrow-right-outline'
                          }}
                        </v-icon>
                      </template>
                      <template v-slot:label="{ item }">{{ item.name }}</template>
                    </v-treeview>
                  </v-col>

                  <v-divider vertical></v-divider>

                  <v-col class="d-flex text-center">
                    <v-scroll-y-transition mode="out-in">
                      <div
                          v-if="!selected"
                          class="text-h6 grey&#45;&#45;text text&#45;&#45;lighten-1 font-weight-light"
                          style="align-self: center;"
                      >Selectionner un utilisateur
                      </div>
                      <v-card v-else :key="selected.id" class="pt-6 mx-auto" flat max-width="600">
                        <v-card-text>
                          <h3 class="text-h5 mb-2">{{ selected.firstname }} {{ selected.lastname }}</h3>
                          <div class="blue&#45;&#45;text mb-2">{{ selected.email }}</div>
                          <span
                              class="subheading font-weight-bold"
                              :class="'selected.active' ? 'blue&#45;&#45;text' : 'orange&#45;&#45;text'"
                          >{{ selected.active ? 'Actif' : 'Innactif' }}</span>
                          <span
                              v-if="selected.isOnPlaceAgentId"
                              class="subheading font-weight-bold ml-1"
                              :class="'selected.active' ? 'blue&#45;&#45;text' : 'orange&#45;&#45;text'"
                          >- Agent sur place</span>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-row class="text-left" tag="v-card-text">
                          <v-col class="text-right mr-4 mt-1" tag="strong" cols="5">Roles:</v-col>
                          <v-col cols="5">
                            <v-chip
                                color="green"
                                outlined
                                pill
                                v-for="(role, index) in selected.roles"
                                :key="index"
                            >{{ role.name }}
                            </v-chip>
                          </v-col>
                          <v-col class="text-right mr-4 mt-1" tag="strong" cols="5">Groupes:</v-col>
                          <v-col cols="5">
                            <v-chip
                                class="ml-1"
                                color="blue"
                                pill
                                outlined
                                v-for="(group, index) in selected.groups"
                                :key="index"
                            >{{ group.name }}
                            </v-chip>
                          </v-col>
                          <v-col class="text-right mr-4 mt-1" tag="strong" cols="5">Sites</v-col>
                          <v-col cols="5">
                            <site-label
                                class="d-inline mx-1"
                                v-for="(site, index) in selected.sites"
                                :key="index"
                                :sitename="site"
                            ></site-label>
                          </v-col>
                        </v-row>
                        <v-divider></v-divider>

                        <v-row class="text-left" tag="v-card-text">
                          <v-col class="text-right mr-4 mt-2" tag="strong" cols="5">Absent:</v-col>
                          <v-col>
                            <v-checkbox
                                dense
                                class="ma-0 pa-0"
                                v-model="selected.vacant"
                                @change="vacant(selected)"
                                label="L'utilisateur ne se verra plus attribuer de dossier durant son absence"
                            ></v-checkbox>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-scroll-y-transition>
                  </v-col>
                </v-row>
              </v-card>
            </v-container>-->
    </template>
  </layout>
</template>
<script>
import {EventBus} from "@/components/commons/event-bus";
import Layout from "@/views/Layout";
import {get, post} from "@/utils/api";
import SiteLabel from "@/components/commons/SiteLabel";
import SmartSelect from "@/components/commons/SmartSelect.vue";
import SmartMultiSelect from "@/components/commons/SmartMultiSelect.vue";

export default {
  components: {
    SmartMultiSelect, SmartSelect,
    Layout, SiteLabel
  },
  data: () => ({
    searchform: {active: [], vacant: [], sites: [], onplaceAgent: []},
    userDialog: {show: false, user: null},
    allSites: [],
    active: [],
    open: [],
    users: [],
    headers: [
      {
        text: "Nom",
        value: "name",
        align: "left",
        width: '10%',
        sortable: true,
      },
      {
        text: "Email",
        value: "email",
        align: "left",
        width: '10%',
        sortable: false,
      },
      {
        text: "Actif",
        value: "active",
        class: 'px-[5px',
        align: "left",
        width: '4%',
        sortable: false,
      },
      {
        text: "Absent",
        value: "vacant",
        align: "left",
        width: '4%',
        sortable: false,
      },
      {
        text: "Groupes",
        value: "groups",
        align: "left",
        width: '12%',
        sortable: false,
      },
      {
        text: "Rôles",
        value: "roles",
        align: "left",
        width: '13%',
        sortable: false,
      },

    ]
  }),

  computed: {
    filteredUsers() {
      return this.users.filter(user => this.searchform.sites.length == 0 || user.sites.some(site => this.searchform.sites.includes(site)))
          .filter(user => this.searchform.active.length == 0 || this.searchform.active.includes(user.active.toString()))
          .filter(user => this.searchform.vacant.length == 0 || this.searchform.vacant.includes(user.vacant.toString()))
          .filter(user => this.searchform.onplaceAgent.length == 0 || this.searchform.onplaceAgent.includes(user.isOnPlaceAgentId.toString()))
    }
  },

  watch: {},
  mounted() {
    this.init()
  },

  methods: {
    async init() {
      await this.loadUsers()
      this.searchform = {
        active: [],
        vacant: [],
        onplaceAgent: [],
        sites: []
      }
    },
    async loadUsers() {
      const url = "/api/search/users";
      await get(url)
          .json((data) => {

            this.allSites = [...data].flatMap(user => user.sites).filter((value, index, array) => {
              return array.indexOf(value) === index;
            })

            this.users = [...data.map(user => {
              const sites = this.allSites.map(site => {
                return {[site]: user.sites.includes(site)}
              })

              return {
                ...user,
                ...sites.reduce((acc, obj) => {
                  Object.assign(acc, obj);
                  return acc;
                }, {})
              }


            })]


            console.log(this.users)


            this.allSites.forEach((site) => {
              this.headers.push({
                text: site,
                value: site,
                align: "center",
                class: "rotate",
                width: '5%',
                sortable: false,
              },)
            })
          })
          .then(() => {
            //this.open = [this.items[0].id]
          });
    },
    vacant(user) {
      const url = `/api/user/${user.id}/update`;
      post(url, user)
          .res((data) => {
            EventBus.$emit("toaster-msg", "Utilisateur mis à jour");
            this.userDialog.show = false
          });
    },
    setVacant() {
      this.userDialog.user.vacant = true
      this.vacant(this.userDialog.user)
    },
    setPresent() {
      this.userDialog.user.vacant = false
      this.vacant(this.userDialog.user)
    },
    changeVacation(item) {
      this.userDialog = {user: item, show: true}
    }
  }
}
</script>
<style scoped>

>>> thead {
  height: 120px !important;
}

>>> th.rotate {
  height: 20px !important;
  width: 40px !important;
  text-transform: none;
  writing-mode: sideways-lr;
  vertical-align: center;
  border-bottom: none
}

</style>